import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LegacySearchMember } from '../model/legacy-search-member.model';

const useLegalEntityV3 = environment.useLegalEntityV3;
const PROJECTION_API =  environment.projectionApi;;
@Injectable({
    providedIn: 'root',
})
export class LegacyMemberService {

    membersCache: LegacySearchMember[] = [];

    constructor(private http: HttpClient) { }

    //used in member-input component
    searchAllMembers(term: string): Observable<LegacySearchMember> {
      
        var memberInCache = this.membersCache.find(m => m.permitNumber === term);
        if (memberInCache) {
            return of(memberInCache);
        }

         if (!useLegalEntityV3) {
            return this.http.get<LegacySearchMember>(`${environment.webApiUrl}/Membres/GetByPermitNumber/${term}`);
        } else {
            const URL = `${PROJECTION_API}/MemberInfo/GetBasicInfo?permitNumbers=${term}`;
            return this.http.get<any>(URL).pipe(
              map(res => res.length > 0 ? this.parseMember(res[0]) : null
            ));
        }  
    }

    addMemberToCache(member: LegacySearchMember) {
        var memberInCache = this.membersCache.find(m => m.permitNumber === member.permitNumber);
        if (!memberInCache) {
            this.membersCache.push(member);
        }
    }

    setMembersCache(membersToAdd: LegacySearchMember[], permitNumbers: string[])  {    
        
        permitNumbers.forEach((p) => { 

          var memberInCache = this.membersCache.find(m => m.permitNumber === p);
          if (!memberInCache) {
            const member = membersToAdd.find(m => m.permitNumber === p);
            if (member) {
                this.addMemberToCache(member);
            } else {
                this.addMemberToCache({ firstName: '', lastName: '', prefix: '', permitNumber: p });
            }   
          }
               
        });
    } 

    getListByPermitNumber(permitNumbers: string[]): Observable<LegacySearchMember[]> {

       //find only those that are not in cache
        var permitNumberInCache = this.membersCache.filter(m=> m.firstName).map((m) => m.permitNumber);
        permitNumbers  = permitNumbers.filter((p) =>  !permitNumberInCache.includes(p));

        if (permitNumbers.length == 0 || permitNumbers.filter((p) => p).length == 0) {
          return of([]);
        }

        const batchSize = 150;
        const batches: Observable<LegacySearchMember[]>[] = [];
        
        for (let i = 0; i < permitNumbers.length; i += batchSize) {
          const itemsInBatch = permitNumbers.slice(i, i + batchSize);
          const itemsInBatchTexte = itemsInBatch.join(',');
          const URL = `${PROJECTION_API}/MemberInfo/GetBasicInfo?permitNumbers=${itemsInBatchTexte}`;

          var items =  this.http.get<LegacySearchMember[]>(URL, { }) 
    
          batches.push(items);
        }
    
        return forkJoin(batches).pipe(
          map((data: LegacySearchMember[][]) => {
            const result: LegacySearchMember[] = [];
            data.map((d) => {
              d.map((i) => result.push(this.parseMember(i)));
            });
            return result;
          })
        );
      }

    private parseMember(item: any): LegacySearchMember {
        return {  firstName: item.firstName, lastName: item.lastName, prefix: item.prefix, permitNumber: item.permitNumber  };
    }

}
